import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import ContentsModal    from 'contents_modal';
// -------------------------------------------------------

class InstaID extends React.Component {
  changeSetting() {
    this.props.set_ev.bind(this)('insta_id', this.insta_id.value);
  }
  // -------------------------------------------------------
  
  render() {
    return (
      <div className="column">
        <h6>アカウントID</h6>
        <input className="text" ref={(input) => { this.insta_id = input }} onBlur={this.changeSetting.bind(this)} placeholder="アカウントIDを入力" />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InstaID;